export default __webpack_public_path__ + "static/media/carTtsIt_It75.1794959d.mp3";